import { render, staticRenderFns } from "./PrivacyStatement.vue?vue&type=template&id=2e47fcb1&scoped=true&"
import script from "./PrivacyStatement.vue?vue&type=script&lang=ts&"
export * from "./PrivacyStatement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e47fcb1",
  null
  
)

export default component.exports